// WebSocketStatusBar.tsx
import React, { FC, useState, useEffect, memo } from '../../../lib/teact/teact';
import './WebSocketStatusBar.css';

import store, { RootState } from '../store';

interface WebSocketStatusBarProps {
    autoHideMs?: number; // 0 = không tự ẩn
}

const statusTextMap: Record<string, string> = {
    connecting: '🔌 Đang kết nối...',
    connected: '🟢 Đã kết nối',
    reconnecting: '⏳ Đang kết nối lại...',
    closed: '🔴 Mất kết nối',
    error: '❗ Lỗi kết nối',
};

const statusColorMap: Record<string, string> = {
    connecting: 'status-connecting',
    connected: 'status-connected',
    reconnecting: 'status-reconnecting',
    closed: 'status-closed',
    error: 'status-error',
};

const getWsStatus = (): string | undefined => {
    const state = store.getState() as RootState;
    return state.wsSlice.status;
};

const WebSocketStatusBar: FC<WebSocketStatusBarProps> = ({ autoHideMs = 0 }) => {
    const [status, setStatus] = useState<string | undefined>(getWsStatus());
    const [visible, setVisible] = useState<boolean>(!!status);

    useEffect(() => {
        let lastStatus = getWsStatus();
        setStatus(lastStatus);
        setVisible(!!lastStatus);

        const unsubscribe = store.subscribe(() => {
            const nextStatus = getWsStatus();
            if (nextStatus !== lastStatus) {
                lastStatus = nextStatus;
                setStatus(nextStatus);
                setVisible(!!nextStatus);

                if (autoHideMs > 0 && nextStatus) {
                    setTimeout(() => {
                        setVisible(false);
                    }, autoHideMs);
                }
            }
        });

        return unsubscribe;
    }, [autoHideMs]);

    if (!visible || !status) return null;

    const statusClass = statusColorMap[status] || 'status-default';
    const statusText = statusTextMap[status] || status;

    return (
        <div className={`ws-status-bar ${statusClass}`}>
            {statusText}
        </div>
    );
};

export default WebSocketStatusBar;